<div class="mini-audio-player">
  <button type="button" class="play-btn" (click)="togglePlay()" [attr.aria-label]="isPlaying ? 'Pause' : 'Play'">
    <svg *ngIf="!isPlaying" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M8 5v14l11-7z" />
    </svg>
    <svg *ngIf="isPlaying" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M6 5h4v14H6zm8 0h4v14h-4z" />
    </svg>
  </button>
  <span class="duration">{{ displayTime }}</span>
</div>
